<template>
  <v-dialog v-model="isOpen" :width="width" :persistent="disableClose">
    <v-card
      data-testid="modal-card"
      :height="height"
      class="iot-dialog flex-column"
      :class="[!isBorderBottom && 'border_bottom']"
    >
      <v-icon
        v-if="!disableClose"
        color="grey-dark"
        size="25"
        class="align-self-end close-icon"
        @click.prevent="closeDialog"
      >
        {{ CONSTANTS.ICONS_MDI.ICON_CLOSE }}
      </v-icon>

      <div class="px-15 py-3">
        <!-- TITLE -->
        <v-card-title class="px-0 py-5">
          <h4
            data-test="page-title"
            class="title-container text-uppercase"
            :class="[`${margin} ${titleClass}`]"
          >
            {{ title }}
          </h4>
        </v-card-title>

        <!-- ADDITIONAL SECTION -->
        <v-card-text class="pr-0 pl-0">
          <slot name="body" />
        </v-card-text>

        <!-- BUTTONS -->
        <v-card-actions v-if="cardActionsEnabled" class="justify-center modal-actions">
          <slot id="btn-group" name="btn-group" />
        </v-card-actions>
      </div>
    </v-card>
  </v-dialog>
</template>

<script lang="ts" setup>
  import CONSTANTS from '@/constants/Config.constants'
  import { computed } from 'vue'

  const emit = defineEmits<{
    (event: 'closeDialog'): void
  }>()
  const props = defineProps({
    isOpen: { type: Boolean, required: true },
    text: { type: String, required: false, default: '' },
    width: { type: String, required: false, default: 'auto' },
    title: { type: String, required: false, default: 'auto' },
    titleClass: { type: String, required: false, default: '' },
    height: { type: String, required: false, default: 'auto' },
    margin: { type: String, required: false, default: '' },
    isBorderBottom: { type: Boolean, required: false, default: true },
    titleIcon: { type: String, required: false, default: '' },
    cardActionsEnabled: { type: Boolean, required: true },
    disableClose: { type: Boolean, required: false, default: false },
  })

  const isOpen = computed({
    get() {
      return props.isOpen
    },
    set(newValue) {
      if (!newValue) {
        closeDialog()
      }
    },
  })

  const title = computed((): string => {
    return props.title
  })

  function closeDialog(): void {
    emit('closeDialog')
  }
</script>

<style lang="scss" scoped>
  .iot-dialog {
    .title-container {
      font-size: 30px;
      font-weight: 300;
      color: rgb(var(--v-theme-font-color));
    }

    .close-icon {
      top: 20px;
      right: 20px;
    }
  }

  .modal-actions {
    padding: 0;
  }
</style>

<!-- Not scoped due to elements being rendered outside of the component -->
<style>
  .v-dialog > .v-overlay__content {
    margin-top: calc(24px + 54px) !important;
    max-height: calc(100% - 48px - 54px) !important;
  }
</style>
